import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import createPersistedState from 'vuex-persistedstate'

const store = new Vuex.Store({
  
  state: {
    // baseUrl:'http://wandaipiaowuadminserver.touchdot.top',//正式
    // baseUrl:'https://java.techolic.cn', //测试
    // baseUrl:'http://127.0.0.1:28326/admin',//测试
    baseUrl:'',
    role:'',
    name:'',
    shopId:'',
    cinemaId:'0',
    merId:'0',
    shopMerId:'0',
    showMerId:'0',
    portType:null,
    withId:"0",
    adminUserId:0,
    limitNum:0,
    limitMoneyNum:0,
    sensitive_Limit:0,
    remove_Limit:0,
    new_Limit:0,
    new_Money_Limit:0,
  },
  plugins: [createPersistedState()],
  mutations: {
    changeRole(state, mode) {
      state.role = mode
    },
    changeAdminUserId(state, mode) {
      state.adminUserId = mode
    },
    changeName(state, newName){
      state.name = newName
    },
    changeShopId(state, shopId){
      state.shopId = shopId
    },
    changeCinemaId(state, cinemaId){
      sessionStorage.setItem('cinemaId',cinemaId)
      state.cinemaId = cinemaId
    },
    changeMerId(state,merId){
      sessionStorage.setItem('merId',merId)
      state.merId = merId
    },
    changeBankId(state,bankId){
      sessionStorage.setItem('bankId',bankId)
      state.bankId = bankId
    },
    changeShopMerId(state,shopMerId){
      sessionStorage.setItem('shopMerId',shopMerId)
      state.shopMerId = shopMerId
    },
    changeShowMerId(state,showMerId){
      sessionStorage.setItem('showMerId',showMerId)
      state.showMerId = showMerId
    },
    changePortType(state,portType){
      sessionStorage.setItem('portType',portType)
      state.portType = portType
    },
    changeWithId(state,withId){
      sessionStorage.setItem('withId',withId)
      state.withId = withId
    },
    changeLimitNum(state,limitNum){
      state.limitNum = limitNum
    },
    changeLimitMoneyNum(state,limitMoneyNum){
      state.limitMoneyNum = limitMoneyNum
    },
    changeSensitive_Limit(state,sensitive_Limit){
      state.sensitive_Limit = sensitive_Limit
    },
    changeRemove_Limit(state,remove_Limit){
      state.remove_Limit = remove_Limit
    },
    changeNew_Limit(state,new_Limit){
      state.new_Limit = new_Limit
    },
    changeNew_Money_Limit(state,new_Money_Limit){
      state.new_Money_Limit = new_Money_Limit
    }
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js